import styled from 'styled-components';
import PropTypes from 'prop-types';
import colors from '../../../config/colors.json';

export const SelectableCard = styled.div`
    border: 1px solid ${colors.lightGrey9};
    padding: 90px 0;
    border-radius: 8px;
	height: 284px;
    &.isSelected {
        border: 1px solid ${colors.greyMidias}
    }
`;

export const CardLogo = styled.div`
    display: flex;
    justify-content: center;
    height: 80%;
`;

export const LogoName = styled.p`
    font-size: 14px;
    text-align: center;
    font: Regular 14px/21px Poppins;
    color: #4D4C59;
    margin: 10px 0px 0px 0px;
`;

export const BtnTrash = styled.button`
    position: absolute;
    top: 0;
    right: 0;
    transform: translateY(-100%);
    background: #FFFFFF 0% 0% no-repeat padding-box;
    opacity: 1;
    border: none;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 20px;
    width: 40px;
    height: 40px;

    &:focus{
        outline: none;
        opacity: 0.8;
    }
`;

export const CardDiv = styled.div`
    cursor: pointer;
    margin-top: ${({ marginTop }) => marginTop};
`;

CardDiv.defaultProps = {
    marginTop: '29px',
};

PropTypes.CardDiv = {
    marginTop: PropTypes.string,
};
